export const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;
export const fmtNum = (n) => (Number(n) || 0).toLocaleString("en-US", { maximumFractionDigits: 2 });
export const vals = (o) => Object.values(o || {});

export function fmtDate(iso, lang, withTime = true) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (lang !== "es" && lang !== "fr") {
    const p = (n) => String(n).padStart(2, "0");
    const date = `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()}`;
    return withTime ? `${date} ${p(d.getHours())}:${p(d.getMinutes())}` : date;
  }
  const loc = lang === "es" ? "es-ES" : "fr-FR";
  const opts = withTime ? { dateStyle: "medium", timeStyle: "short" } : { dateStyle: "medium" };
  return d.toLocaleString(loc, opts);
}

export const daysUntil = (dateStr) => Math.ceil((new Date(dateStr) - new Date()) / 86400000);

export function expiryStatus(p) {
  if (!p.expiry) return null;
  const d = daysUntil(p.expiry);
  if (d < 0) return "expired";
  if (d <= 14) return "soon";
  return "ok";
}

export const isLow = (p, def = 5) => (p.stock || 0) <= (p.low_stock ?? def);

export function uuid() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
}

export function genEan13() {
  const d = `20${Array.from({ length: 10 }, () => Math.floor(Math.random() * 10)).join("")}`;
  const sum = [...d].reduce((s, c, i) => s + Number(c) * (i % 2 ? 3 : 1), 0);
  return d + ((10 - (sum % 10)) % 10);
}

export async function sha256(text) {
  const buf = await window.crypto.subtle.digest("SHA-256", new TextEncoder().encode(text));
  return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, "0")).join("");
}

export function download(filename, content, type = "application/json") {
  const url = URL.createObjectURL(new Blob([content], { type }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
